<xm-problem-widget-view
  [items]="problemItems()"
  [title]="'Problem Listing'"
  [searchFn]="searchProblems$"
  [canAdd]="canAdd()"
  [canDelete]="canDelete()"
  [isProcessing]="isProcessing()"
  (itemAdded)="onItemSelected($event.item)"
  (itemRemoved)="onItemRemoved($event)"
  (addNewItem)="onAddNewItem($event)">
</xm-problem-widget-view>
